import ResponsiveBanner from "template-store/components/banner/responsive-banner/responsive-banner";
import { componentStyles } from "./banner.scss";

const DESKTOP_BANNER_PLACEHOLDER_LINK =
  "https://dapulse-res.cloudinary.com/image/upload/f_auto,q_auto/mondayhomepage/template-store/banners-images/main_banner_image-no-padding.png";

const MOBILE_BANNER_PLACEHOLDER_LINK =
  "https://dapulse-res.cloudinary.com/image/upload/f_auto,q_auto/mondayhomepage/template-store/banners-images/mobile_banner.png";

const Banner = (props) => {
  return (
    <div className="banner-component">
      <div className="desktop-wrapper">
        <ResponsiveBanner imageLink={DESKTOP_BANNER_PLACEHOLDER_LINK} {...props} />
      </div>

      <div className="mobile-wrapper">
        <ResponsiveBanner isMobileBanner imageLink={MOBILE_BANNER_PLACEHOLDER_LINK} {...props} />
      </div>

      <style jsx>{componentStyles}</style>
    </div>
  );
};

export default Banner;
